import Meta from 'vue-meta'
import Vue2Filters from 'vue2-filters'
import Vuelidate from 'vuelidate'
import { EventBus } from '../eventBus'
import DataFilter from '../DataFilter'

Vue.use(Vue2Filters)
Vue.use(Meta)
Vue.use(Vuelidate)

Vue.mixin({
    mounted() {
        this.disableAutoComplete();
    },

    methods: {
        disableAutoComplete() {
            let elements = document.querySelectorAll('[autocomplete="off"]');

            if (!elements) {
                return;
            }

            elements.forEach(element => {
                element.setAttribute('readonly', 'readonly');
                element.style.backgroundColor = 'inherit';

                setTimeout(() => {
                    element.removeAttribute('readonly');
                    element.style.backgroundColor = null;
                }, 1000);
            });
        }
    }
});

Vue.config.productionTip = false;

window.Vue = window.Vue || Vue;
window.VueEventBus = window.VueEventBus || EventBus;
window.VueDataFilter = window.VueDataFilter || DataFilter;

export default {
  Vue, EventBus, DataFilter
}
